import { Controller } from "@hotwired/stimulus"

// Dieser Controller verwaltet den "Active"-Status der Sidebar-Links
export default class extends Controller {
  static targets = ["link"]

  // Wird aufgerufen, wenn die Seite oder der Frame geladen wird
  connect() {
    this._updateActiveState()
  }

  // Diese Methode wird durch das 'click->sidebar#setActive' Event im HTML aufgerufen
  setActive(event) {
    // Entferne die Klasse von allen Links
    this.linkTargets.forEach(link => link.classList.remove("active"))
    
    // Füge die Klasse dem gerade geklickten Link hinzu
    event.currentTarget.classList.add("active")
  }

  // Private Methode, um den Status anhand der aktuellen URL zu prüfen (falls die Seite neu geladen wird)
  _updateActiveState() {
    const currentUrl = window.location.href
    this.linkTargets.forEach(link => {
      if (link.href === currentUrl) {
        link.classList.add("active")
      }
    })
  }
}
